export default __webpack_public_path__ + "static/media/17.09db836a.png";